import React from "react";
import rehypeReact from "rehype-react";
import styled from "styled-components";
import Helmet from "../components/allpages/Helmet";
import ExtraTip from "../components/allpages/ExtraTip";
import Leerdoelen from "../components/grammatica/Leerdoelen";
import Klaar from "../components/grammatica/Klaar";
import Tip from "../components/allpages/Tip";
import Wrapper from "../components/grammatica/Wrapper";

const renderAst = new rehypeReact({
  createElement: React.createElement,
  components: {
    t: Tip,
    x: ExtraTip
  }
}).Compiler;

const Title = styled.h1``;

const Post = styled.div`
  margin-bottom: 2em;
`;

export default ({ data }) => {
  const post = data.markdownRemark;
  const { book, chapter, title } = post.frontmatter;
  return (
    <Wrapper>
      <Helmet data={data} />
      <Title>{title}</Title>
      <Leerdoelen book={book} chapter={chapter} type="voorkennis" />
      <Post>{renderAst(post.htmlAst)}</Post>
      <Leerdoelen book={book} chapter={chapter} type="leerdoelen" />
      <Klaar book={book} chapter={chapter} />
    </Wrapper>
  );
};

export const query = graphql`
  query grammaticaQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      htmlAst
      frontmatter {
        book
        chapter
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/grammatica.js